import { Link } from "gatsby";

export const useButtonProps = ({ link, url, asset }) => {
    if (link?.startsWith("/") || url?.startsWith("/")) {
        return {
            as: Link,
            to: link || url,
        };
    }

    return {
        as: "a",
        href: link || url || asset.url,
        target: "_blank",
        rel: "noreferrer",
    };
};
